export const SET_EXPORTS_FILTER = 'SET_EXPORTS_FILTER';
export const SET_CUSTOM_REPORTS_FILTER = 'SET_CUSTOM_REPORTS_FILTER';
export const SET_INTEGRATIONS_FILTER = 'SET_INTEGRATIONS_FILTER';
export const SET_AB_TESTING_FILTER = 'SET_AB_TESTING_FILTER';
export const SET_MEDIA_LIBRARY_FILTER = 'SET_MEDIA_LIBRARY_FILTER';
